import { Button, Column, Heading, If, Modal, ModalProps, Row } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { StudentNote, StudentNoteNoteType, useStudentNoteDetailQuery } from "../../../../Utilities";
import { StudentNoteFormat } from "../../../Format";
import { DetailDisplayStudentNote, StudentNoteDetailDisplay } from "../DetailDisplay";
import { StudentNoteIcon } from "../Icon";

export type ModalStudentNote = DetailDisplayStudentNote;

export type ControlledStudentNoteModalProps = Omit<StudentNoteModalProps, "isLoading" | "studentNote"> & {
	studentNoteID: StudentNote["id"];
};

export function ControlledStudentNoteModal({ studentNoteID, ...props }: ControlledStudentNoteModalProps) {
	const { loading, data } = useStudentNoteDetailQuery({ variables: { id: studentNoteID } });

	return <StudentNoteModal isLoading={loading} studentNote={data?.studentNote} {...props} />;
}

export type StudentNoteModalProps = {
	isLoading?: boolean;
	studentNote: ModalStudentNote | null | undefined;
	noteType?: StudentNoteNoteType;
	withBackButton?: boolean;
	backButtonText?: string;
} & Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function StudentNoteModal({
	isLoading,
	studentNote,
	noteType,
	withBackButton = false,
	backButtonText = "Back to Notes",
	ifRef,
	onClose,
	className,
	style,
}: StudentNoteModalProps) {
	const headerStudentNote = studentNote ?? (noteType ? { noteType } : null);

	return (
		<Modal ifRef={ifRef} onClose={onClose} className={className} style={{ width: "50rem", height: "40rem", ...style }}>
			{!!headerStudentNote && (
				<Modal.Header>
					<Column justify="spaced-start" verticalSpacing="0.25rem" style={{ marginRight: "1.5rem" }}>
						<If condition={withBackButton}>
							{onClose && (
								<Button variant="link" size="small" onClick={onClose}>
									<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem">
										<Icon.ArrowLeft size={14} /> {backButtonText}
									</Row>
								</Button>
							)}
						</If>

						<Row justify="spaced-start" align="center">
							<StudentNoteIcon studentNote={headerStudentNote} size={22} />
							<Heading.H2 noMargin>{StudentNoteFormat.Fields.noteType(headerStudentNote.noteType)}</Heading.H2>
						</Row>
					</Column>
				</Modal.Header>
			)}
			<Modal.Body>
				<StudentNoteDetailDisplay isLoading={isLoading} studentNote={studentNote} style={{ height: "100%" }} />
			</Modal.Body>
		</Modal>
	);
}
